export default "__VITE_ASSET__dccca76f__"